import { type FileSelectionFieldProps } from "../../files/file-selection-field/file-selection-field.types";
import { FileSelectionFieldWithUrl } from "../../files/file-selection-field-with-url/FileSelectionFieldWithUrl.component";
import { OfferFilesTable } from "../offer-files-table";

export const OfferFileSelectionFieldWithUrl = (props: FileSelectionFieldProps) => (
	<FileSelectionFieldWithUrl {...props} tableComponent={OfferFilesTable} />
);
